import gsap from 'gsap';
import { Eases } from './eases';


export const TransitionDirection = {
    BACK: 'back',
    NEXT: 'next',
};

export const TransitionViewRenderers = {
    SCHEDULES_VIEW: 'schedulesViewRenderer',
    CALENDARS_VIEW: 'calendarsViewRenderer',
    SUBSCRIBER_VIEW: 'subscriberViewRenderer',
    OAUTH_LAUNCHER_VIEW: 'oauthLauncherViewRenderer',
    ALMOST_DONE_VIEW: 'almostDoneViewRenderer',
    OAUTH_LOADING_VIEW: 'oauthLoadingViewRenderer',
    SUCCESS_VIEW: 'successViewRenderer',
    HAVING_TROUBLE_VIEW: 'havingTroubleViewRenderer',
    ICSLINK_VIEW: 'icsLinkViewRenderer',
    ICSLINK_OUTLOOK_VIEW: 'icsLinkOutlookViewRenderer',
    OAUTH_FAILED_VIEW: 'oauthFailedViewRenderer',
    INAPP_GUIDE_VIEW: 'inAppGuideViewRenderer',
};

export const TransitionViewNames = {
    SCHEDULES_VIEW: 'schedule-view',
    CALENDARS_VIEW: 'calendars-view',
    SUBSCRIBER_VIEW: 'subscriber-view',
    OAUTH_LAUNCHER_VIEW: 'oauth-launcher-view',
    ALMOST_DONE_VIEW: 'almost-done-view',
    OAUTH_LOADING_VIEW: 'oauth-loading-view',
    OAUTH_FAILED_VIEW:  'oauth-failed-view',
    SUCCESS_VIEW: 'success-view',
    HAVING_TROUBLE_VIEW: 'having-trouble-view',
    ICSLINK_VIEW: 'icslink-view',
    ICSLINK_OUTLOOK_VIEW: 'icslink-outlook-view',
    INAPP_GUIDE_VIEW: 'inapp-guide-view',
};

function slideInFromBack (props)  {
    const {
        target,
        duration,
        onStart = () => {},
        onComplete = () => {},
    } = props;

    const xFrom = {
        x: -250,
    };

    const xTo = {
        ease: Eases.ExpoInOut,
        x: 0,
        duration,
        onStart,
        onComplete,
    };

    const aFrom = {
        opacity: 0,
    };

    const aTo = {
        ease: Eases.ExpoInOut,
        opacity: 1,
        duration,
    };

    gsap.set(target, { ...xFrom, ...aFrom }); 
    gsap.fromTo(target , xFrom, xTo);
    gsap.fromTo(target, aFrom, aTo);
}

function slideOutToBack (props)  {
    const {
        target,
        duration,
        onStart = () => {},
        onComplete = () => {},
    } = props;

    const xFrom = {
        x: 0,
    };

    const xTo = {
        ease: Eases.ExpoInOut,
        x: -250,
        duration,
        onStart,
        onComplete,
    };

    const aFrom = {
        opacity: 1,
    };

    const aTo = {
        ease: Eases.ExpoInOut,
        opacity: 0,
        duration,
    };

    gsap.set(target, { ...xFrom, ...aFrom }); 
    gsap.fromTo(target , xFrom, xTo);
    gsap.fromTo(target, aFrom, aTo);
}

function slideInFromNext (props)  {
    const {
        target,
        duration,
        onStart = () => {},
        onComplete = () => {},
    } = props;


    const xFrom = {
        x: 250,
    };

    const xTo = {
        ease: Eases.ExpoInOut,
        x: 0,
        duration,
        onStart,
        onComplete,
    };

    const aFrom = {
        opacity: 0,
    };

    const aTo = {
        ease: Eases.ExpoInOut,
        opacity: 1,
        duration,
    };

    gsap.set(target, { ...xFrom, ...aFrom }); 
    gsap.fromTo(target , xFrom, xTo);
    gsap.fromTo(target, aFrom, aTo);

}

function slideOutToNext (props)  {
    const {
        target,
        duration,
        onStart = () => {},
        onComplete = () => {},
    } = props;

    const xFrom = {
        x: 0,
    };

    const xTo = {
        ease: Eases.ExpoInOut,
        x: 250,
        duration,
        onStart,
        onComplete,
    };

    const aFrom = {
        opacity: 1,
    };

    const aTo = {
        ease: Eases.ExpoInOut,
        opacity: 0,
        duration,
    };

    gsap.set(target, { ...xFrom, ...aFrom }); 
    gsap.fromTo(target , xFrom, xTo);
    gsap.fromTo(target, aFrom, aTo);
}

const transitions = {
    slideInFromBack,
    slideOutToBack,
    slideInFromNext,
    slideOutToNext,
};

export default transitions;
